import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ServiceBase } from '@app/services/base.service';

@Injectable()
export class HomeService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  obterListaMeAvise(buscarAgendaDeOutroUsuarioId: number, ordemCampo: string, ordemTipo: string): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `home/obterMeAvise/?buscarAgendaDeOutroUsuarioId=${buscarAgendaDeOutroUsuarioId}&ordem=${ordemCampo}&tipo=${ordemTipo}`);
  }

  obterPrazoAdvogado(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `home/obterPrazoAdvogado/`);
  }



  obterMeAviseAudienciaHoje(buscarAgendaDeOutroUsuarioId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `home/obterMeAviseAudienciaHoje/?buscarAgendaDeOutroUsuarioId=${buscarAgendaDeOutroUsuarioId}`);
  }

}
